import { bookAdd } from "../action";

const addBook = (book, filterStatus) => {
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books", {
      method: "POST",
      body: JSON.stringify({
        ...book,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const books = await response.json();

    filterStatus ? (books?.featured && dispatch(bookAdd(books))) : dispatch(bookAdd(books)) ;
  };
};

export default addBook;
